/**
 * Created by JasonChou on 17/1/21.
 */
const state = {
  screen: {
    width: 0,
    height: 0
  }
};


const mutations = {
  SET_SCREEN_INFO (state, w, h) {
    state.screen.width = w;
    state.screen.height = h;
  }
};

export default {
  state,
  mutations
}



// WEBPACK FOOTER //
// ./src/vuex/stores/common.js